export default __webpack_public_path__ + "static/media/martinize_cg_color.273cbeb4.png";